
module.directive('voterRegistrationForm', function(makeBasicForm, ModelService) {
    return makeBasicForm({
        templateUrl: 'students/demographics/voterRegistrationForm',
        scope: {participant: '='},
        copyData: function(scope) {
            return { registered_voter: scope.participant.registered_voter };
        },
        save: function(scope, data) {
            return ModelService.patchModel(scope.participant, data);
        }
    });
});

module.directive('studentDemographicsForm', function(ModelService, moment) {
    var fields = ['sex', 'birth_date', 'race', 'race_description',
                  'marital_status', 'parental_status', 'housing_status',
                  'foster_care', 'english_learner', 'economically_disadvantaged',
                  'lgbtq_identity', 'recently_employed', 'registered_voter',
                  'first_generation_college', 'disability'],
        selectFields = ['marital_status', 'parental_status', 'housing_status',
                        'foster_care'],
        booleanFields = ['economically_disadvantaged', 'english_learner'],
        yesNoUnknowns = ['lgbtq_identity', 'recently_employed',
                         'first_generation_college', 'disability'];
    return {
        restrict: 'E',
        templateUrl: 'students/demographics/studentDemographicsForm',
        scope: {participant: '=', enrollmentStart: '=', enrollmentEnd: '='},
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            scope.data = ModelService.copyFields(scope.participant, fields);
            basicForm.data = scope.data;
            scope.form = basicForm.getForm()

            if (scope.enrollmentStart) {
                scope.booleanFields = booleanFields;
                scope.yesNoUnknowns = yesNoUnknowns;
                scope.selectFields = selectFields;
            } else {
                scope.booleanFields = ['economically_disadvantaged'];
            }
            scope.raceChecks = {};

            scope.age = null;

            scope.$watchGroup(['enrollmentStart', 'data.birth_date'],
                function() {
                    if (moment.isMoment(scope.enrollmentStart) &&
                            moment.isMoment(scope.data.birth_date)) {
                        scope.age = scope.enrollmentStart.diff(
                            scope.data.birth_date, 'years');
                    } else {
                        age = null;
                    }
                });

            basicForm.save = function(data) {
                var copy = angular.copy(data), i;
                copy.race_description = {};
                for (i = 0; i < data.race.length; i++) {
                    copy.race_description[data.race[i]] =
                        data.race_description[data.race[i]] || null;
                }
                return ModelService.patchModel(scope.participant, copy);
            }
        }
    }
});